import { getTokenFromStorage } from './get-token-from-storage';

export const getTokenValue = () => {
  const token = getTokenFromStorage();

  return token ? token?.access_token : null;
};
